import React, { Fragment, useState } from 'react';
import { Flex, Box, Heading, Text, Card, Button } from 'rebass';
import styled from 'styled-components';

const TabsRow = styled(Flex)`
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 20px;
`;

const TabButton = styled.button`
  border: none;
  cursor: pointer;

  padding: 8px 22px;
  border-radius: 999px;

  font-size: 15px;
  font-weight: 500;

  transition: all 0.2s ease;

  background: ${({ active }) => (active ? '#30466f' : '#ffffff')};

  color: ${({ active }) => (active ? '#ffffff' : '#30466f')};

  box-shadow: ${({ active }) => (active ? 'none' : '0 2px 12px rgba(0,0,0,0.04)')};

  &:hover {
    transform: translateY(-1px);
  }
`;

const ContentCard = styled(Box)`
  h4 {
    color: #30466f;
    margin: 0 0 12px;
  }

  p,
  li {
    color: #56657f;
    line-height: 1.7;
  }

  ul {
    margin: 0;
    padding-left: 18px;
  }
`;

export function PalomRxProductTabControl({ tabs }) {
  const [isExpanded, setIsExpanded] = useState(true);
  const [activeTab, setActiveTab] = useState(tabs[0].id);

  const activeContent = tabs.find((tab) => tab.id === activeTab);

  return (
    <Card style={{ display: 'flex', flexDirection: 'column', gap: 20, background: '#F0F5FE', padding: 20, borderRadius: 12 }}>
      <Flex justifyContent={'space-between'} onClick={() => setIsExpanded(!isExpanded)}>
        <Heading>Product Details</Heading>
        {/* <Text fontSize={20}>+</Text> */}
      </Flex>
      {!!isExpanded && (
        <Flex flexDirection={'column'}>
          <TabsRow>
            {tabs.map((tab) => (
              <TabButton key={tab.id} active={activeTab === tab.id} onClick={() => setActiveTab(tab.id)}>
                {tab.label}
              </TabButton>
            ))}
          </TabsRow>
          {activeContent && <ContentCard>{activeContent.content}</ContentCard>}
        </Flex>
      )}
    </Card>
  );
}
